import type { FileUpload } from '@axinom/mosaic-ui';
import type { ExportServiceAccountsMutation } from '../../../../generated/id-service-env-administration';

export type IncomingServiceAccount =
  ExportServiceAccountsMutation['exportServiceAccounts']['serviceAccounts'][number];

export interface ConflictState {
  hasUnresolvedConflicts: boolean;
  hasNothingToImport: boolean;
}

export interface ImportFormData {
  serviceAccountsJson: FileUpload;
  conflictResolution: ConflictResolutions;
  conflictState: ConflictState;
}

export interface ImportSummary {
  id: string;
  detectedItems: number;
  conflicts: number;
}

export type ImportPreview = Pick<
  IncomingServiceAccount,
  'name' | 'isProtected'
> & {
  importAction: ImportActions;
};

export enum ConflictResolutions {
  NotSelected = '',
  OverwriteAll = 'Overwrite All',
  OverwriteNonProtected = 'Overwrite Non-Protected',
  Skip = 'Skip',
}

export enum ImportActions {
  Create = 'Create',
  Conflict = 'Conflict',
  Overwrite = 'Overwrite',
  Skip = 'Skip',
}

export const resolutionOptions = [
  {
    value: ConflictResolutions.NotSelected,
    label: ConflictResolutions.NotSelected,
  },
  {
    value: ConflictResolutions.OverwriteAll,
    label: ConflictResolutions.OverwriteAll,
  },
  {
    value: ConflictResolutions.OverwriteNonProtected,
    label: ConflictResolutions.OverwriteNonProtected,
  },
  { value: ConflictResolutions.Skip, label: ConflictResolutions.Skip },
];
